import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { bootstrap } from './game/store.js';
import './ui/styles.css';

const host = document.getElementById('root');
if (!host) throw new Error('Нет #root — проверь index.html');

// Сейв поднимаем до первого кадра, чтобы не мигать новой игрой поверх старой.
await bootstrap();

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
